import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee';
import warehouse from '../class/warehouse';
import "../styles/ProductListPage.css";

const ProductListPage = () => {
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const warehouseData = new warehouse();
            const callData = await warehouseData.getProducts();
            const productList = callData?.products || (Array.isArray(callData) ? callData : []);
            setProducts(productList);
        } catch (error) {
            console.error("Error fetching the data", error);
        }
    };

    useEffect(() => {
        let user_obj = new employee();
        user_obj.isLogged().then((info) => {
            setUserInfo(info);
            fetchData();
        }).catch(() => {
            navigate('/login');
        });
    }, []);

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return "0,00000";
        return Number(value).toLocaleString('it-IT', {
            minimumFractionDigits: 5,
            maximumFractionDigits: 5,
        });
    };

    const handleCheckboxChange = (product) => {
        setSelectedProducts((prev) => {
            const exists = prev.find(p => p.order_uuid === product.order_uuid);
            if (exists) {
                return prev.filter(p => p.order_uuid !== product.order_uuid);
            } else {
                return [...prev, product];
            }
        });
    };

    const isSelected = (order_uuid) => {
        return selectedProducts.some(p => p.order_uuid === order_uuid);
    };

    const handleRowClick = (product) => {
        navigate(`/products/${product.order_uuid}`);
    };

    const handleDischarge = () => {
        const emp = new employee();
        const storedUserInfo = emp.getUserInfo();
        navigate('/discharge', { state: { selectedProducts, userInfo: storedUserInfo } });
    };

    return (
        <div className="product-list-page">
            <div className="page-header">
                <h2 className='page-title'>Magazzino Prodotto Finito</h2>
                <button className="btn-indietro" onClick={() => navigate('/discharge-history')}>
                    Storico Scarichi
                </button>
            </div>
            <div className="product-list">
                <div className="product-item">
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th className="checkbox-col"></th>
                                <th>N. Ordine Produzione</th>
                                <th>N. Ordine Cliente</th>
                                <th>Lotto</th>
                                <th>Cod. Articolo</th>
                                <th>Descrizione</th>
                                <th>UM</th>
                                <th>Qtà Prodotta</th>
                                <th>Qtà Scaricata</th>
                                <th>Qtà Disponibile</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map(product => (
                                <tr className='order' key={product.order_uuid}>
                                    <td className="checkbox-col" onClick={(e) => e.stopPropagation()}>
                                        <input
                                            type="checkbox"
                                            checked={isSelected(product.order_uuid)}
                                            onChange={() => handleCheckboxChange(product)}
                                        />
                                    </td>
                                    <td onClick={() => handleRowClick(product)}>{product.order_production_number}</td>
                                    <td onClick={() => handleRowClick(product)}>{product.number_customer_reference_order}</td>
                                    <td onClick={() => handleRowClick(product)}>{product.lot}</td>
                                    <td onClick={() => handleRowClick(product)}>{product.cod_article_las}</td>
                                    <td onClick={() => handleRowClick(product)}>{product.article_descr}</td>
                                    <td onClick={() => handleRowClick(product)}>{product.um}</td>
                                    <td onClick={() => handleRowClick(product)}>{formatNumber(product.produced_quantity)}</td>
                                    <td onClick={() => handleRowClick(product)}>{formatNumber(product.discharged_quantity)}</td>
                                    <td onClick={() => handleRowClick(product)}>{formatNumber(product.available_quantity)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {selectedProducts.length > 0 && (
                <div className="discharge-action-bar">
                    <button className="blue_butt discharge-btn" onClick={handleDischarge}>
                        Scarica Selezionati ({selectedProducts.length})
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProductListPage;
